/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPayDiamondInfo.vue?vue&type=template&id=42c8c292&scoped=true"
import script from "./popPayDiamondInfo.vue?vue&type=script&lang=js"
export * from "./popPayDiamondInfo.vue?vue&type=script&lang=js"
import style0 from "./popPayDiamondInfo.vue?vue&type=style&index=0&id=42c8c292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8c292",
  null
  
)

export default component.exports